module.exports = __webpack_public_path__ + "static/img/logo.0d7d2f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/logo.png
// module id = 3WPC
// module chunks = 1